import { getSearchPromosResponseMk } from '../../__stubs__/promos/searchPromos';
import { ISearchPromosResponse } from '../../repositories/newbuilding-promos/v1/search-promos';

// TODO: Запросить в CD-203174 новую ручку по аналогии с resolveSearchPromosPageV2.
export async function resolveSearchPromosPageV2(): Promise<ISearchPromosResponse> {
  return getSearchPromosResponseMk({});
}
